import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import { PromotedBranchContext } from '../context/context'
import InputText from '../../common/InputText'
import { getRequest } from '../../../services/base'
import useDebouncedValue from '../../../utils/common_function'
import CheckBox from '../../common/CheckBox'
import Button from '../../common/Button'

const SelectMakeModelModal = () => {
  const [state, dispatch] = useContext(PromotedBranchContext)
  const [searchVehicles, setSearchVehicles] = useState('')
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const debouncedToSearchVehicles = useDebouncedValue(searchVehicles, 1000)

  const [vehiclesList, setVehiclesList] = useState([])
  useEffect(() => {
    getVehiclesList()
  }, [])

  const getVehiclesList = async (search = '') => {
    let res = await getRequest(`/api/vehicles/?search=${search}&limit=25`)
    setVehiclesList(res?.results)
  }

  useEffect(() => {
    getVehiclesList(searchVehicles)
  }, [debouncedToSearchVehicles])

  const selectVehicle = async () => {
    if (
      window.confirm(
        `Are sure want to promote changes for selected vehicle`
      ) === true
    ) {
      dispatch({
        type: 'show_hide_file_selection_popup',
        data: true,
        selectedVehicle: selectedVehicle,
        showVehicleModal: false,
        selectedFiles: {},
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: 'show_hide_vehicle_popup', data: false })
      }}
      show={state?.showVehicleModal}
      size={`w-full`}
    >
      <ModalHeader className={'text-white'}>
        <div className="flex items-center text-base justify-between">
          <div className="w-full">Select Vehicles</div>
          <InputText
            name="search_value"
            placeholder={`Search Make Model`}
            className={`w-full`}
            value={searchVehicles}
            isFullSize={true}
            type="search"
            onChange={(value) => {
              setSearchVehicles(value)
            }}
            isRequired={false}
            wrapperClass={`pl-0`}
          />
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-row flex-wrap text-white text-lg w-full">
          {vehiclesList?.map((vehicle, vehicleIdx) => {
            return (
              <div
                className="flex w-1/4 table_text"
                key={`vehicle-${vehicleIdx}`}
              >
                <div className={`px-2 flex w-full items-center`}>
                  <CheckBox
                    onChange={(e) => {
                      setSelectedVehicle(vehicle)
                    }}
                    checked={
                      selectedVehicle?.vehicle_id === vehicle?.vehicle_id
                    }
                  />

                  <span className="px-2">
                    {vehicle.name} ({vehicle.make_model_id})
                  </span>
                </div>
              </div>
            )
          })}
        </div>
        {selectedVehicle?.name && (
          <div className="flex flex-row pt-4 items-center justify-end">
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              text={`Promote Changes Of ${selectedVehicle?.name}`}
              onClick={() => {
                selectVehicle()
              }}
            />
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default SelectMakeModelModal
